// extracted by mini-css-extract-plugin
export var container = "_go-0";
export var content = "_go-3";
export var customerTitle = "_go-4";
export var empty = "_go-5";
export var gray = "_go-6";
export var header = "_go-7";
export var info = "_go-8";
export var loading = "_go-2";
export var loadingCard = "_go-9";
export var oneLine = "_go-a";
export var personName = "_go-e";
export var pillContainer = "_go-b";
export var selected = "_go-1";
export var text = "_go-c";
export var twoLines = "_go-d";
export var unread = "_go-f";
export var unreadIndicator = "_go-g";